if (!customElements.get('kealis-slideshow')) {
  customElements.define('kealis-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (target, event, fn) => target.addEventListener(event, fn, { signal: this.abort.signal });
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelector('.kealis-hero__controls').hidden = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.focused = false;
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, i) => on(dot, 'click', () => this.show(i, true)));
      on(this.querySelector('[data-pause]'), 'click', () => { this.paused = !this.paused; this.schedule(); });
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.schedule(); });
      on(this, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      on(this, 'touchstart', event => { this.touch = [event.touches[0].clientX, event.touches[0].clientY]; });
      on(this, 'touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch[0];
        const dy = event.changedTouches[0].clientY - this.touch[1];
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1), true);
        this.touch = null;
      });
      on(document, 'shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (i >= 0) { this.paused = true; this.show(i, true); }
      });
      this.schedule();
    }
    show(next, manual = false) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (manual) this.querySelector('[data-status]').textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const button = this.querySelector('[data-pause]');
      button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      button.textContent = this.paused ? '▶' : '❚❚';
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}
